// import { initializeApp } from "firebase/app";
// import { getFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
// import { getAuth } from "firebase/auth";
// import { getStorage } from "firebase/storage"; // ✅ ADD

// const firebaseConfig = {
//   apiKey: "AIzaSyBdjTQOzYdhlBX_jvQMwjJ3AuJaHZ8918Q",
//   authDomain: "mykyc-83b53.firebaseapp.com",
//   projectId: "mykyc-83b53",
//   storageBucket: "mykyc-83b53.firebasestorage.app",
//   messagingSenderId: "823306402682",
//   appId: "1:823306402682:web:2c7485a29473986131b4c3",
//   measurementId: "G-BEE8B5ES1W",
// };

// Initialize Firebase

// const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
// export const db = getFirestore(app);
// export const auth = getAuth(app);
// export const storage = getStorage(app); // ✅ ADD

// NEW

import { initializeApp, getApp, getApps } from "firebase/app";
import { initializeFirestore } from "firebase/firestore";
// import { getAnalytics } from "firebase/analytics";
import { getAuth, setPersistence, inMemoryPersistence } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBdjTQOzYdhlBX_jvQMwjJ3AuJaHZ8918Q",
  authDomain: "mykyc-83b53.firebaseapp.com",
  projectId: "mykyc-83b53",
  storageBucket: "mykyc-83b53.firebasestorage.app",
  messagingSenderId: "823306402682",
  appId: "1:823306402682:web:2c7485a29473986131b4c3",
  measurementId: "G-BEE8B5ES1W",
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

// Firestore Listen can be blocked by some browsers/networks. Auto-detecting
// long polling keeps realtime listeners reliable without forcing it everywhere.
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
});
export const auth = getAuth(app);
export const storage = getStorage(app);

// ✅ secondary app (public upload link) — DOES NOT share auth state with staff app
const publicApp =
  getApps().find((a) => a.name === "publicUpload") ||
  initializeApp(firebaseConfig, "publicUpload");

export const publicAuth = getAuth(publicApp);
// ✅ critical: isolate it from your normal browser persistence (prevents clobbering staff login)
setPersistence(publicAuth, inMemoryPersistence);

export const publicStorage = getStorage(publicApp);
